import type {StoryblokFieldPublish, StoryblokFieldSeo} from '../types';

export function isStoryblokPublishField(field: unknown): field is StoryblokFieldPublish {
  return !!field && typeof field === 'object' && 'type' in field && field.type === 'bttr-publish';
}

export function isStoryblokSeoField(field: unknown): field is StoryblokFieldSeo {
  return !!field && typeof field === 'object' && (
    ('type' in field && field.type === 'bttr-seo')
    || ('title' in field && 'description' in field && 'services' in field) // For backwards compatibility
  );
}
